import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import type { DividerBlock } from '../types';
import styles from './Divider.module.css';
interface DividerProps {
  block: DividerBlock;
  blockId: string;
}
export function Divider(t0) {
  const $ = _c(5);
  const {
    block,
    blockId
  } = t0;
  const t1 = block.variant === "featurette" ? styles.featurette : null;
  let t2;
  if ($[0] !== t1) {
    t2 = [styles.divider, t1].filter(Boolean);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const className = t2.join(" ");
  let t3;
  if ($[2] !== blockId || $[3] !== className) {
    t3 = <hr className={className} data-cms-block-id={blockId} data-cms-field="divider" />;
    $[2] = blockId;
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}